import './index.css';

/**
 * 无更多数据提示
 * @param apiData
 */
export default function ({ apiData }) {
  return (
    <view className="no-more-tip" style={{ height: apiData?.height }}>
      <text className="txt" content={apiData?.text || ''} />
    </view>
  );
}
